import { createActionCreator, paramsEncode } from '../../../utils';
import request from '../../../utils/request';
import constant from './constant';
import Urls from '../../../../config/index';
import { url } from '../statistics-view/reducers';

export const createLoadingAction = createActionCreator(constant.loading, loading => loading);
export const createStatisticsListAction = createActionCreator(constant.statisticList, list => list);
export const createSearchAction = createActionCreator(constant.search, o => o);
export const createAgentsAction = createActionCreator(constant.agents, list => list);
export const createAreasAction = createActionCreator(constant.areas, list => list);
export const createStatisticsTotalAction = createActionCreator(constant.statisticTotal, list => list);
export const createExportUrlAction = createActionCreator(constant.url, o => o);


let taskStatisticUrl = Urls.TaskStatisticUrl;
let partnerUrl = Urls.PartnerUrl;
let advertPositionDataUrl = Urls.AdvertPositionDataUrl;
let exportUrl = Urls.AdvertPositionDataUrl.exportUrl;



// 获取合作、地区列表
export const getAgentsAndAreas = () => {
    return async (dispatch, getState) => {
        try {
            let response = await request(partnerUrl.paramList);
            dispatch(createAgentsAction(response.partnerName));
            dispatch(createAreasAction(response.area));
        } catch (e) {
            throw new Error(e);
        }
    }
}


//获取数据统计（表格数据）
export const getStatisticTotal = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(createLoadingAction(true));
            let search = getState().advertPositionDataCurve.search;
            let response = await request(taskStatisticUrl.total + paramsEncode(Object.assign({}, search, { beginTimeView: '' }, { endTimeView: '' })));
            dispatch(createStatisticsTotalAction(response));
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createLoadingAction(false));
        }
    }
}



export const getExportUrl = () => {
    return (dispatch, getState) => {
        //let search = getState().report.search;
        let search = getState().advertPositionDataCurve.search;
        let str = "";
        let i = 0;
        //typeof (obj) == "undefined"
        for(let key in search){
            if(typeof(search[key])!=="undefined" && search[key]){
                if(i==0){
                    str = "?" +str + key+"="+search[key];
                }else{
                    str = str + "&" + key+"="+search[key];
                }
                i++;
            }
        }
        //let url = exportUrl + paramsEncode(Object.assign({}, search, { filtration: undefined }));
        let url = exportUrl + str;
        dispatch(createExportUrlAction(url));
       
    }
}


//获取数据统计列表接口(图标数据)
export const getStatisticList = () => {
    return async (dispatch, getState) => {
        try {
            let search = getState().advertPositionDataCurve.search;
            //let response = await request(advertPositionDataUrl.curve + paramsEncode(Object.assign({}, search, { beginTimeView: '' }, { endTimeView: '' })));
            let response = await request(advertPositionDataUrl.curve,"POST",search);

            dispatch(createStatisticsListAction(response));
        } catch (e) {
            throw new Error(e);
        }
    }
}

//
export const onFieldsChange = (search) => {
    return (dispatch, getState) => {
        dispatch(createSearchAction(search));
    }
}



// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/advertPositionDataCurve/action.js